import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';
import { useRoute } from '@react-navigation/native';
import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { ExchangeIntroductionDesktop } from './ExchangeIntroductionDesktop.component';
import { ExchangeIntroductionMobile } from './ExchangeIntroductionMobile.component';

export interface ExchangeIntroductionProps {}

export const ExchangeIntroductionScreen: React.FC<ExchangeIntroductionProps> = () => {
  const layout = useContext(LayoutContext);
  const route = useRoute();

  if (layout.isMobile) {
    return (
      <UtxAppEmbed route={route.name}>
        <ExchangeIntroductionMobile />
      </UtxAppEmbed>
    );
  }
  return <ExchangeIntroductionDesktop />;
};
